/**
 * Time Module is a reusable Module to use time and duration features
 */

// Angular
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

// Own Components
import {TimeFieldComponent} from "./time-field.component";
import {TextFieldModule} from "../text-field/text-field.module";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TextFieldModule
    ],
    declarations: [
        TimeFieldComponent
    ],
    exports: [
        TimeFieldComponent
    ]
})

export class TimeFieldModule { }
